<template>
  <div class="md-layout md-gutter md-alignment-center">
    <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-50 md-xsmall-size-100">
      <tab-content></tab-content>
      <!-- <md-card
        md-with-hover
        style="width:100%"
      >
        <md-ripple>
          <md-card-content>
            <div style="min-height:260px;"> 
            <tab-content></tab-content>
            </div>
          </md-card-content>
        </md-ripple>
      </md-card> -->
    </div>
    <div class="md-layout-item md-size-66 md-medium-size-66 md-small-size-50 md-xsmall-size-100">
      <md-card
        md-with-hover
        style="width:100%"
      >
        <md-ripple>
          <md-card-content>
            <div
              class="md-layout md-gutter md-alignment-center"
              style="width:100%"
            >
              <div class="md-layout-item md-size-66 md-medium-size-66 md-small-size-66 md-xsmall-size-100">
                <div>
                  <Link :href="{path:'news',query:{newId:item.id}}" :label="item.title" v-for="(item,index) in getNewList" :key="index"/>
                </div>
                <!-- <md-list>
                  <md-list-item v-for="(item,index) in getNewList" :key="index">{{item.title}}</md-list-item>
                </md-list> -->
              </div>
              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-hide">
                <img src="http://test.00800.com.cn/pc/2d2fa6b47b1bb142be7520ff868059f.jpg" />
              </div>
            </div>

          </md-card-content>
        </md-ripple>
      </md-card>
    </div>
  </div>
</template>

<script>
import TabContent from './TabContent.vue'
import Link from '@/components/Link/index'
import {getAllNews} from '@/api/news.js'
export default {
  components:{
    TabContent,
    Link
  },
  data(){
    return {
      newList:[]
    }
  },
  created(){
    this.initData()
  },
  computed:{
    getNewList(){
      //返回前n条抽奖数据    
      const count = 8  
      return this.newList.slice(0,count)
    },
  },
  methods:{
    initData(){
      getAllNews().then(res=>{
        // console.log(res)
        this.newList = res.data
        this.$store.commit('Update_NewsList',res.data)
        // console.log(this.$store.state.news)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine
.md-layout-item {
  margin-top: 8px;
  margin-bottom: 8px;
  transition: 0.3s;

  &:after {
    width: 100%;
    height: 100%;
    display: block;
    background: md-get-palette-color(purple, 200);
    content: " ";
  }
}
</style>